const chainRpcs = {
    // FSN
    "32659":{
        "rpcUrl":"https://mainnet.fusionnetwork.io",
        "scanUrl":"https://fsnscan.com"
    },
    // ETH
    "1":{
        "rpcUrl":"https://rpc.ankr.com/eth",
        "scanUrl":"https://etherscan.io"
    },
    // BNB
    "56":{
        "rpcUrl":"https://rpc.ankr.com/bsc",
        "scanUrl":"https://bscscan.com"
    },
    // HT
    "128":{
        "rpcUrl":"https://http-mainnet.hecochain.com",
        "scanUrl":"https://www.hecoinfo.com/en-us"
    },
    // OKC
    "66":{
        "rpcUrl":"https://exchainrpc.okex.org",
        "scanUrl":"https://www.oklink.com/en/okc"
    },
    // AVAXC
    "43114":{
        "rpcUrl":"https://rpc.ankr.com/avalanche",
        "scanUrl":"https://snowtrace.io"
    },
    // FTM
    "250":{
        "rpcUrl":"https://rpc.ankr.com/fantom",
        "scanUrl":"https://ftmscan.com"
    },
    // ETC
    "61":{
        "rpcUrl":"https://www.ethercluster.com/etc",
        "scanUrl":"https://www.oklink.com/en/etc"
    },
    // ETHW
    "10001":{
        "rpcUrl":"https://mainnet.ethereumpow.org",
        "scanUrl":"https://www.oklink.com/en/ethw"
    },
    // ETHF
    "513100":{
        "rpcUrl":"https://rpc.etherfair.org",
        "scanUrl":"https://www.oklink.com/en/ethf"
    },
    // FUSE
    "122":{
        "rpcUrl":"https://fuse-pokt.nodies.app",
        "scanUrl":"https://explorer.fuse.io/"
    },
    // POLYGON
    "137":{
        "rpcUrl":"https://rpc.ankr.com/polygon",
        "scanUrl":"https://polygonscan.com"
    },
    // AURORA
    "1313161554":{
        "rpcUrl":"https://mainnet.aurora.dev",
        "scanUrl":"https://aurorascan.dev"
    },
    // CAD
    "256256": {
        "rpcUrl":"https://mainnet.block.caduceus.foundation",
        "scanUrl":"https://mainnet.scan.caduceus.foundation/"
    },
    // METIS
    "1088":{
        "rpcUrl":"https://andromeda.metis.io/?owner=1088",
        "scanUrl":"https://andromeda-explorer.metis.io"
    },
    // CIC
    "1353":{
        "rpcUrl":"https://xapi.cicscan.com",
        "scanUrl":"https://cicscan.com/"
    },
    // RSK
    "30":{
        "rpcUrl":"https://public-node.rsk.co",
        "scanUrl":"https://explorer.rsk.co"
    },
    // TARA
    "841":{
        "rpcUrl":"https://rpc.mainnet.taraxa.io",
        "scanUrl":"https://mainnet.explorer.taraxa.io"
    },
    // KLAY
    "8217":{
        "rpcUrl":"https://cypress.fandom.finance/archive",
        "scanUrl":"https://scope.klaytn.com"
    },
    // CRO
    "25":{
        "rpcUrl":"https://evm-cronos.crypto.org",
        "scanUrl":"https://cronoscan.com"
    },
    // CANTO
    "7700":{
        "rpcUrl":"https://canto.slingshot.finance",
        "scanUrl":"https://evm.explorer.canto.io"
    },
    // CORE
    "1116":{
        "rpcUrl":"https://rpc.coredao.org",
        "scanUrl":"https://scan.coredao.org"
    },
    // ELA
    "20":{
        "rpcUrl":"https://rpc.glidefinance.io",
        "scanUrl":"https://eth.elastos.io"
    },
    // CFXEVM
    "1030": {
        "rpcUrl":"https://evm.confluxrpc.com",
        "scanUrl":"https://evm.confluxscan.net/"
    },
    // SYSEVM
    "57":{
        "rpcUrl":"https://rpc.syscoin.org",
        "scanUrl":"https://explorer.syscoin.org"
    },
    // FEVM
    "314":{
        "rpcUrl":"https://rpc.ankr.com/filecoin",
        "scanUrl":"https://filscan.io"
    },
    // TELOSEVM
    "40": {
        "rpcUrl":"https://mainnet.telos.net/evm",
        "scanUrl":"https://www.teloscan.io/"
    },
    // ARB
    "42161":{
        "rpcUrl":"https://rpc.ankr.com/arbitrum",
        "scanUrl":"https://arbiscan.io"
    },
    // OP
    "10":{
        "rpcUrl":"https://opt-mainnet.g.alchemy.com/v2/JzmIL4Q3jBj7it2duxLFeuCa9Wobmm7D",
        "scanUrl":"https://optimistic.etherscan.io"
    },
    // BASE
    "8453":{
        "rpcUrl":"https://base.blockpi.network/v1/rpc/public",
        "scanUrl":"https://basescan.org"
    },
    // LINEA
    "59144":{
        "rpcUrl":"https://rpc.linea.build",
        "scanUrl":"https://lineascan.build/"
    },
    // ZKEVM
    "1101":{
        "rpcUrl":"https://polygon-zkevm.blockpi.network/v1/rpc/public",
        "scanUrl":"https://zkevm.polygonscan.com"
    },
    // ZKSYNC
    "324":{
        "rpcUrl":"https://mainnet.era.zksync.io",
        "scanUrl":"https://www.oklink.com/cn/zksync"
    },
    // OPBNB
    "204":{
        "rpcUrl":"https://opbnb.publicnode.com",
        "scanUrl":"https://opbnbscan.com"
    },
    // ROLLUX
    "570":{
        "rpcUrl":"https://rpc.rollux.com",
        "scanUrl":"https://explorer.rollux.com"
    },
    // CUBE
    "1818":{
        "rpcUrl":"https://http-mainnet-archive.cube.network",
        "scanUrl":"https://www.cubescan.network/en-us"
    },
    // SHIBA
    "109":{
        "rpcUrl":"https://www.shibrpc.com",
        "scanUrl":"https://www.shibariumscan.io"
    },
    // SCROLL
    "534352":{
        "rpcUrl":"https://scroll-mainnet.public.blastapi.io",
        "scanUrl":"https://blockscout.scroll.io/"
    }
}

export default chainRpcs